// PublicLayout.js
import React from 'react';
import { Outlet } from 'react-router-dom';

const PublicLayout = () => {
  return (
    <div>
      {/* Common header or navigation for public pages */}
      <Outlet />
    </div>
  );
};


export default PublicLayout;
